var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9007 6.05611C13.2913 5.66559 13.9244 5.66559 14.315 6.05611L18.4958 10.237C18.8863 10.6275 18.8863 11.2607 18.4958 11.6512L10.7206 19.4264C10.33 19.8169 9.69688 19.8169 9.30636 19.4264L5.1255 15.2456C4.73498 14.855 4.73498 14.2219 5.1255 13.8314L12.9007 6.05611ZM13.6078 8.17744L7.24682 14.5385L10.0135 17.3051L16.3745 10.9441L13.6078 8.17744Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81418 12.3915C8.10707 12.0986 8.58195 12.0986 8.87484 12.3915L10.1398 13.6565C10.4327 13.9494 10.4327 14.4243 10.1398 14.7172C9.84694 15.0101 9.37207 15.0101 9.07917 14.7172L7.81418 13.4522C7.52129 13.1593 7.52129 12.6844 7.81418 12.3915Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88129 10.3244C10.1742 10.0315 10.6491 10.0315 10.9419 10.3244L12.2069 11.5894C12.4998 11.8823 12.4998 12.3572 12.2069 12.65C11.914 12.9429 11.4392 12.9429 11.1463 12.65L9.88129 11.3851C9.58839 11.0922 9.58839 10.6173 9.88129 10.3244Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6322 7.94101C11.9251 7.64812 12.4 7.64812 12.6929 7.94101L16.8041 12.0522C17.097 12.3451 17.097 12.82 16.8041 13.1129C16.5112 13.4058 16.0364 13.4058 15.7435 13.1129L11.6322 9.00167C11.3393 8.70878 11.3393 8.23391 11.6322 7.94101Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4865 4.6419C11.877 4.25138 12.5102 4.25138 12.9007 4.6419L19.9718 11.713C20.3623 12.1035 20.3623 12.7367 19.9718 13.1272C19.5813 13.5177 18.9481 13.5177 18.5576 13.1272L11.4865 6.05611C11.096 5.66559 11.096 5.03242 11.4865 4.6419Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1487 4.22234C16.5392 3.83181 17.1724 3.83181 17.5629 4.22234L20.3913 7.05076C20.7819 7.44129 20.7819 8.07445 20.3913 8.46498C20.0008 8.8555 19.3676 8.8555 18.9771 8.46498L18.27 7.75787L16.8558 9.17208C16.4653 9.56261 15.8321 9.56261 15.4416 9.17208C15.0511 8.78156 15.0511 8.14839 15.4416 7.75787L16.8558 6.34366L16.1487 5.63655C15.7582 5.24603 15.7582 4.61286 16.1487 4.22234Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07106 16.5427C8.46158 16.9332 8.46158 17.5664 8.07106 17.9569L5.24263 20.7853C4.8521 21.1758 4.21894 21.1758 3.82842 20.7853C3.43789 20.3948 3.43789 19.7616 3.82842 19.3711L6.65684 16.5427C7.04737 16.1521 7.68053 16.1521 8.07106 16.5427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.f4d5096e4d905fc44aad95b389be00d7.svg";
export { ForwardRef as ReactComponent };